
export default {
    title: "3proj",
    vars:{
    },
}
